var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalAgreements',{attrs:{"get-url":"/space/get-terms-and-conditions","title":_vm.$t('labels.termsandconditions')}})}
var staticRenderFns = []

export { render, staticRenderFns }